import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';

const BackButton = ({ isDark, onClick }) => (
  <Button
    text="Back"
    icon="arrow-left-linear"
    variant="tertiary"
    size="small"
    onClick={onClick}
    wrapperClassName="AuthShell__back"
    className={cn(
      'rounded-lg',
      isDark && '!border-neutral-dark-700 !bg-neutral-dark-800 hover:!bg-neutral-dark-700'
    )}
    textClassName={cn('text-sm', isDark && '!text-white')}
    iconColor={isDark ? 'white' : 'neutral'}
    data-qa="auth-back-btn"
  />
);

export default BackButton;
